import React from 'react';
import { Button, Paper, Tooltip, Typography } from '@mui/material';
import { KeyboardArrowRight } from '@mui/icons-material';
import { Box } from '@mui/system';
import { styled } from '@mui/material';
import { experimental_sx as sx } from '@mui/material';
import { NOTIFICATION_OBJECT } from '../../shared/constants';
import { useNavigate } from 'react-router-dom';
import { redirectionData } from '../../shared/helper';
import RewardPointsIcon from '../../assests/mpoweredCoinTransparent.svg';

const customValues = {
  paper: {
    width: {
      dashboard: { xs: 150, sm: 246 },
      service: { xs: 152, sm: 152 },
      standard: { xs: 130, sm: 200 },
    },
    height: {
      dashboard: { xs: 137, sm: 150 },
      service: { xs: 76, sm: 76 },
      standard: { xs: 77, sm: 120 },
    },
    p: {
      dashboard: 1.5,
      service: 0,
      standard: 1.5,
    },
    elevation: {
      dashboard: 2,
      service: 0,
      standard: 2,
    },
    border: {
      dashboard: 'none',
      service: '1px solid #CFCFCF',
      standard: 'none',
    },
  },
  container: {
    pl: {
      dashboard: { sm: 1, xs: 1 },
      service: { sm: '12px', xs: '12px' },
      standard: { sm: 2, xs: 1 },
    },
    pt: {
      dashboard: { sm: 1, xs: 0 },
      service: '12px',
      standard: { sm: 2, xs: 0 },
    },
  },
  image: {
    width: {
      dashboard: { sm: 40, xs: 30 },
      service: 24,
      standard: { sm: 40, xs: 24 },
    },
    height: {
      dashboard: { sm: 40, xs: 30 },
      service: 24,
      standard: { sm: 40, xs: 24 },
    },
  },
  description: {
    typography: {
      dashboard: 'body1',
      service: 'bannerMobile',
      standard: { sm: 'body1', xs: 'bannerMobile' },
    },
    mt: {
      dashboard: { sm: 1, xs: 1 },
      service: 0.5,
      standard: { sm: 1, xs: 0.5 },
    },
  },
};

const IconPaper = styled(Paper)(({ height, width, padding, border }) =>
  sx({
    bgcolor: 'paper.main',
    height: height ? height : { xs: 77, sm: 120 },
    width: width ? width : { xs: 130, sm: 200 },
    borderRadius: '12px',
    p: padding,
    position: 'relative',
    border: border,
  })
);

const IconBox = styled(Box)(({ leftPadding, paddingTop }) =>
  sx({
    display: 'flex',
    justifyContent: 'left',
    pl: leftPadding,
    pt: paddingTop,
    flexDirection: 'column',
  })
);

const ImageBox = styled(Box)(({ height, width }) =>
  sx({
    height: height,
    width: width,
  })
);

const CustomTypography = styled(Typography)(({ typography, marginTop }) =>
  sx({
    typography: typography,
    mt: marginTop,
  })
);

const renderDemoText = text => {
  if (text === 'Care Plans') {
    return NOTIFICATION_OBJECT[text];
  } else if (text === 'Appointments') {
    return NOTIFICATION_OBJECT[text];
  } else if (text === 'Bills') {
    return NOTIFICATION_OBJECT[text];
  } else {
    return NOTIFICATION_OBJECT[text];
  }
};

export const IconContainer = ({
  route,
  imgUrl,
  caption,
  origin,
  demoUI = false,
}) => {
  const navigate = useNavigate();

  const navigateToPage = () => {
    if (demoUI && route !== '/financial/bills') {
      navigate(route, { state: redirectionData(route) });
    } else {
      navigate(route);
    }
  };

  return (
    <Box
      onClick={() => navigateToPage()}
      sx={{ textDecoration: 'none', cursor: 'pointer' }}>
      <IconPaper
        height={customValues.paper.height[origin]}
        width={customValues.paper.width[origin]}
        padding={customValues.paper.p[origin]}
        border={customValues.paper.border[origin]}
        elevation={customValues.paper.elevation[origin]}>
        <Box sx={{ position: 'absolute', top: 12, right: 12 }}>
          <KeyboardArrowRight />
        </Box>
        <IconBox
          leftPadding={customValues.container.pl[origin]}
          paddingTop={customValues.container.pt[origin]}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}>
            <ImageBox
              component="img"
              height={customValues.image.height[origin]}
              width={customValues.image.width[origin]}
              src={imgUrl}
              alt={caption}
            />
            {demoUI &&
              (route === '/care/assessments' ||
                route === '/care/carePlans') && (
                <Tooltip title='Earn reward points by completing these actions' placement='top'>
                  <Box sx={{ marginLeft: '60px', display: 'flex' }}>
                    <Typography
                      sx={{
                        marginRight: '5px',
                        fontWeight: 600,
                        fontSize: '16px',
                      }}>
                      {route === '/care/assessments' ? 1000 : 100}
                    </Typography>
                    <ImageBox
                      component="img"
                      height="40"
                      width="40"
                      src={RewardPointsIcon}
                      alt="Reward Icon"
                    />
                  </Box>
                </Tooltip>
              )}
          </Box>
          <Box sx={{ mt: { sm: 1, xs: 0.5 } }}>
            <CustomTypography
              typography={customValues.description.typography[origin]}
              marginTop={customValues.description.mt[origin]}>
              {demoUI ? renderDemoText(caption) : caption}
            </CustomTypography>
          </Box>
        </IconBox>
      </IconPaper>
    </Box>
  );
};
